import { Button } from '@spark-web/button';
import { Inline } from '@spark-web/inline';
import { REPAYMENT_ACCOUNT } from '../../utils/constants';

type Props = {
  onClose: () => void;
  setValue: (value: string) => void;
  watch: (name: string) => string;
};

function Actions({ onClose, watch, setValue }: Props) {
  const name = 'termsAndConditions.directDebitStatement';
  const agreed = watch(name);

  const handleClick = () => {
    setValue(REPAYMENT_ACCOUNT.DIRECT_DEBIT_AGREEMENT ?? '');
    onClose();
  };

  return (
    <Inline gap="small" align="right" paddingBottom="medium">
      <Button tone="neutral" onClick={onClose}>
        Close
      </Button>
      {agreed ? null : (
        <Button tone="positive" onClick={handleClick}>
          Agree
        </Button>
      )}
    </Inline>
  );
}

export default Actions;
